'use strict';

var React = require('react');
var _require = require('relay-runtime'),
  createRelayContext = _require.__internal.createRelayContext;
module.exports = createRelayContext(React);